export default __webpack_public_path__ + "images/8L.f121d90.png";